import request from '@/axios'

// D-客户-04-获取节点平分问题列表
export function getQuestionInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/sidebar/complaint/getQuestionInfo',
    method: 'post',
    data
  })
}

// D-客户-05-提交用户节点评分
export function saveQuestionnaire(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/sidebar/complaint/saveQuestionnaire',
    method: 'post',
    data
  })
}

// D-客诉-03-添加客诉
export function saveComplaint(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/sidebar/complaint/saveComplaint ',
    method: 'post',
    data
  })
}

